import { render, staticRenderFns } from "./circleTable.vue?vue&type=template&id=248cda10&scoped=true"
import script from "./circleTable.vue?vue&type=script&lang=js"
export * from "./circleTable.vue?vue&type=script&lang=js"
import style0 from "./circleTable.vue?vue&type=style&index=0&id=248cda10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248cda10",
  null
  
)

export default component.exports